<template>
    <div>
        <div class="form-group col-12">
            <label>Audio</label>
            <media-chooser :value="audio" type="audio" @input="onAudioChange" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            audio: {},
            id: Math.random()
                .toString(36)
                .substring(2, 15)
                .match(/[a-zA-Z]+/g)
                .join('')
        };
    },

    mounted() {
        this.audio = { ...this.value };
    },

    methods: {
        onAudioChange(audio) {
            this.audio = { ...audio };

            this.$emit('input', this.audio);
        }
    }
};
</script>
